import React, {ReactElement} from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import qs from 'qs';
import CheckedValue from '../CheckedValue';
import Button from 'src/components/button';
import {useDispatch} from 'react-redux';
import switchAccount from 'shared/actions/switch-account';
import NullComponent from 'src/components/NullComponent';

const renderTakeOverButton = (_value, {id}): ReactElement => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const dispatch = useDispatch();
  const reason = 'Take over account from list of college portal users';

  return (
    <Button
      buttonName="take-over"
      className="pull-left"
      onClick={(): void => {
        localStorage.setItem('impersonationReturnUrl', window.location.href);
        dispatch(switchAccount(id, reason));
      }}
      horizontalMargin
    >
      Take Over
    </Button>
  );
};

const columns: ColumnSettings[] = [
  {
    name: 'email',
    title: 'Email',
    sortable: true,
  },
  {
    name: 'experienceEverywhereSamlId',
    title: 'Experience SAML ID',
    sortable: true,
  },
  {
    name: 'firstName',
    title: 'First Name',
    sortable: true,
  },
  {
    name: 'lastName',
    title: 'Last Name',
    sortable: true,
  },
  {
    name: 'messagingEnabled',
    title: 'Messaging',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'targetMeEnabled',
    title: 'TargetMe',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'manageEmailAliasesEnabled',
    title: 'ManageEmailAliases',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
  {
    name: 'takeOver',
    title: '',
    renderValue: renderTakeOverButton,
    FormField: NullComponent,
  },
];

interface CollegePortalUsersProps {
  queryOptions: Record<string, string>;
}

const CollegePortalUsers = (props: CollegePortalUsersProps): React.ReactElement => {
  const options = qs.stringify(props.queryOptions || {});

  return (
    <EditableTable
      basePath={`/v1/college-portal-users?sortBy=email&fields=email,firstName,lastName,messagingEnabled,targetMeEnabled,manageEmailAliasesEnabled,experienceEverywhereSamlId&${options}`}
      defaultSortKey="email"
      columns={columns}
      identifier={props.queryOptions.universityId || 'college-portal-users'}
    />
  );
};

export default CollegePortalUsers;
